export default __webpack_public_path__ + "static/media/water.39bdad10.png";